import React, { useState, useEffect, useRef } from "react";

import ArrowDown from '../../assets/icons/icon-arrow-down-alone-gray.png';

import * as S from "./styles";
import { theme } from "../../styles/theme";
import { TaglineG, TaglineM } from "../../styles/stylesTypography";

const FilterV2 = ({ filterOptions, onBlurFilter, children, startDateValue, endDateValue }) => {
  const [isDispensed, setIsDispensed] = useState(false);
  const [openSelect, setOpenSelect] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [selectionChanged, setSelectionChanged] = useState(false);
  const selectRef = useRef(null);
  const [openChildrenSelect, setOpenChildrenSelect] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const toggleSelect = (filter) => {
    if (filter !== "data_evento") {
      setOpenChildrenSelect(false)
    }

    if (openSelect === filter && selectionChanged) {
      if (onBlurFilter) {
        onBlurFilter(selectedOptions, filterOptions, isDispensed);
      } // envia os filtros atualizados
      setSelectionChanged(false); // reseta
    }

    setOpenSelect(openSelect === filter ? null : filter);
  };

  useEffect(() => {
    if (openSelect === null) {
      setSearchTerm("");
    }
  }, [openSelect]);

  const toggleChildrenSelect = () => {
    setOpenChildrenSelect(!openChildrenSelect);
  };

  const selectOption = (filter, value) => {
    setSelectionChanged(true);

    setSelectedOptions((prev) => {
      const currentSelections = prev[filter] || [];

      const updatedSelections = currentSelections.includes(value)
        ? currentSelections.filter((item) => item !== value)
        : [...currentSelections, value];

      return { ...prev, [filter]: updatedSelections };
    });
  };

  const selectedOptionsRef = useRef(selectedOptions);

  useEffect(() => {
    selectedOptionsRef.current = selectedOptions;
  }, [selectedOptions]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        if (openSelect && selectionChanged) {
          if (onBlurFilter) {
            onBlurFilter(selectedOptions, filterOptions, isDispensed);
          }
          setSelectionChanged(false);
        }
  
        setOpenSelect(null);
        setOpenChildrenSelect(false);
      }
    };
  
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openSelect, selectionChanged, onBlurFilter]);

  useEffect(() => {
    selectedOptionsRef.current = selectedOptions;
  }, [selectedOptions]);
  
  useEffect(() => {
    if (onBlurFilter) {
      onBlurFilter(selectedOptions, filterOptions, isDispensed);
    }
  }, [isDispensed]);

  const hasDateValues = startDateValue || endDateValue;

  return (
    <S.Container ref={selectRef}>
      {Object.keys(filterOptions).map((filter) => {
        const isSelected = selectedOptions[filter] && selectedOptions[filter].length > 0;

        return (
          <S.CustomSelect key={filter}>
            <S.SelectButton 
              onClick={() => toggleSelect(filter)} 
              selected={isSelected}
            >
              <TaglineM
                color={isSelected ? "#FFF" : theme.colors.gray.Cinza_2}
                fontWeight={800}
                cursor="pointer"
              >
                {filter}
              </TaglineM>

              <S.Arrow className={openSelect === filter ? "open" : ""} selected={isSelected}>
                <img src={ArrowDown} alt="Seta Apontada para baixo" style={{ width: "16px", height: "auto" }}/>
              </S.Arrow>
            </S.SelectButton>

            {openSelect === filter && (
              <S.SelectOptions>
                <S.SearchInputContainer>
                  <input
                    type="text"
                    placeholder="Buscar"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                  />
                </S.SearchInputContainer>
                <S.OptionsList>
                  {filterOptions[filter]
                    .filter((option) => (option?.label || "").toLowerCase().includes((searchTerm || "").toLowerCase()))
                    .map((option) => (
                      <S.Option key={`${filter}_${option.id}`} onClick={() => selectOption(filter, option.id)}>
                        <input
                          type="checkbox"
                          checked={selectedOptions[filter]?.includes(option.id) || false}
                          onChange={() => selectOption(filter, option.id)}
                          onClick={(e) => e.stopPropagation()}
                        />
                        <span>{option.label}</span>
                      </S.Option>
                    ))}
                </S.OptionsList>
              </S.SelectOptions>
            )}
          </S.CustomSelect>
        );
      })}

      {children && (
        <S.CustomSelect key={"data_evento"}>
          <S.SelectButton 
            onClick={() => {
              toggleChildrenSelect()
              toggleSelect("data_evento");
            }}
            selected={hasDateValues}
          >
            <TaglineM
              color={hasDateValues ? "#FFF" : theme.colors.gray.Cinza_2}
              fontWeight={800}
              cursor="pointer"
            >
              Data do evento
            </TaglineM>

            <S.Arrow className={openChildrenSelect ? "open" : ""} selected={hasDateValues}>
              <img src={ArrowDown} alt="Seta Apontada para baixo" style={{ width: "16px", height: "auto" }}/>
            </S.Arrow>
          </S.SelectButton>

          {openChildrenSelect && (
            <S.SelectOptions>
              {children}
            </S.SelectOptions>
          )}
        </S.CustomSelect>
      )}

      <S.ContainerSwitch onClick={() => setIsDispensed(!isDispensed)}>
          <S.SwitchContainer isActive={isDispensed} setIsDispensed={setIsDispensed}>
            <S.SwitchCircle isActive={isDispensed} setIsDispensed={setIsDispensed} />
          </S.SwitchContainer>

          <TaglineG color={theme.colors.gray.Cinza_2} fontWeight={600}>
            Ocultar canceladas
          </TaglineG>
      </S.ContainerSwitch>
    </S.Container>
  );
};

export default FilterV2;